import { ReservationStatus } from '@ac/library-api';

export function isNextUseReservationInActiveStatus(
  status?: ReservationStatus
): boolean {
  return [ReservationStatus.DI, ReservationStatus.RS].includes(
    status ?? ReservationStatus.CX
  );
}



// WEBPACK FOOTER //
// ./src/shared/reservations/isNextUseReservationInActiveStatus.ts